import React from 'react';
import Switch from '@mui/material/Switch';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { styled } from '@mui/material/styles';

const SWITCH_DIMENSIONS = {
  height:30, // width is 2*height
  padding:3,
  icon_size_scale: 0.9,
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: SWITCH_DIMENSIONS.height*2,
  height: SWITCH_DIMENSIONS.height,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: SWITCH_DIMENSIONS.padding,
    '&.Mui-checked': {
      transform: `translateX(${SWITCH_DIMENSIONS.height}px)`,
    },
  },
  '& .MuiSwitch-thumb': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .MuiSwitch-track': {
    borderRadius: SWITCH_DIMENSIONS.height/2,
    height: SWITCH_DIMENSIONS.height,
    opacity: 1,
  },
  '& .MuiSvgIcon-root': {
    fontSize: (SWITCH_DIMENSIONS.height - SWITCH_DIMENSIONS.padding) * SWITCH_DIMENSIONS.icon_size_scale,
  },
}));

function ThemeToggle({ theme, toggleTheme }) {
  return (
    <StyledSwitch
      className="theme-toggle" // Added for positioning by LandingText.css
      checked={theme === 'dark'}
      onChange={toggleTheme}
      checkedIcon={<DarkModeIcon />} // Icon for dark mode
      icon={<LightModeIcon />} // Icon for light mode
    />
  );
}

export default ThemeToggle;